// -------------------------------------------------
// スクロール禁止 + スクロールバー幅のずれ補正
// -------------------------------------------------
let scrollTop = 0;
let lockCount = 0;

function getScrollbarWidth() {
  return window.innerWidth - document.documentElement.clientWidth;
}

function isScrollLocked() {
  return document.documentElement.classList.contains('is-hidden');
}

function lockBodyScroll() {
  lockCount += 1;
  if (lockCount > 1) return;

  const html = document.documentElement;
  const body = document.body;
  const scrollbarWidth = getScrollbarWidth();

  scrollTop = window.scrollY;
  html.style.top = `${scrollTop * -1}px`;
  html.classList.add('is-hidden');

  html.style.setProperty('--scrollbar-compensation', `${scrollbarWidth}px`);
  if (scrollbarWidth > 0) {
    body.style.paddingRight = `${scrollbarWidth}px`;
  }
}

function applyUnlockStyles() {
  const html = document.documentElement;
  const body = document.body;
  const restoreY = scrollTop;

  html.style.top = '';
  html.classList.remove('is-hidden');
  html.style.setProperty('--scrollbar-compensation', '0px');
  body.style.paddingRight = '';

  const prevHtmlBehavior = html.style.scrollBehavior;
  const prevBodyBehavior = body.style.scrollBehavior;
  html.style.scrollBehavior = 'auto';
  body.style.scrollBehavior = 'auto';

  window.scrollTo(0, restoreY);

  html.style.scrollBehavior = prevHtmlBehavior;
  body.style.scrollBehavior = prevBodyBehavior;
}

function unlockBodyScroll() {
  if (lockCount === 0) return;
  lockCount -= 1;
  if (lockCount > 0) return;

  applyUnlockStyles();
}

function forceUnlockBodyScroll() {
  if (lockCount === 0 && !document.documentElement.classList.contains('is-hidden')) {
    return;
  }
  lockCount = 0;
  applyUnlockStyles();
}

function scrollBan() {
  if (document.documentElement.classList.contains('is-hidden')) {
    forceUnlockBodyScroll();
  } else {
    lockBodyScroll();
  }
}
